import {gql} from '@apollo/client';
import {ACCOUNT_CONTACT_FRAGMENT, ACCOUNT_CONTACT_SLOW} from '../../graphql/fragments';

const LIST_CONTACTS = gql`
  query ListContacts($accountId: UUID!) {
    contacts(accountId: $accountId) {
      ...AccountContact
    }
  }
  ${ACCOUNT_CONTACT_FRAGMENT}
`;

export const LIST_CONTACTS_SLOW = gql`
  query ListContactsSlow($accountId: UUID!) {
    contacts(accountId: $accountId) {
      ...AccountContactSlow
    }
  }
  ${ACCOUNT_CONTACT_SLOW}
`;

export const GET_FACT_FINDS = gql`
  query GetFactFinds($accountId: UUID!) {
    getFactFinds(accountId: $accountId)
  }
`;

export default LIST_CONTACTS;
